<template>
    <btn-history-back text="戻る" @back-page-clicked="handleBackClick"/>
</template>
<script>
import BtnHistoryBack from './BtnHistroyBack.vue'

/**
 * 戻るボタン（アプリwebviewへの通知付き）
 */
export default {
    name: 'BtnHistoryBackNotify',
    components: {
        BtnHistoryBack,
    },
    methods: {
        /**
         * アプリwebviewからも使われる、「同意して戻るボタン」クリック時の処理
         * webviewでの戻る先の存在にかかわらず、同意して戻るボタンを押したことをアプリに通知する
         * note: 本来はwebviewでの戻る先の存在によって通知の有無を変えるべきだが、実装現在のweb APIにおいて"canGoBack"のような判定が正確にできないため。
         * (本当は`if(navigation.canGoBack) return;`のようなことがしたい)
         * experimentalでcanGoBackが存在するので、正式に使えるようになれば、そのタイミングで修正する
         * https://developer.mozilla.org/en-US/docs/Web/API/Navigation/canGoBack
         */
        handleBackClick() {
            // iOS
            window.webkit?.messageHandlers?.agreeAndBackPressed?.postMessage('agreeAndBackPressed');
            // Android
            window.Android?.handleAgreeAndBackPressed?.();
        }
    }
}
</script>
